<template>
  <div>
    <ul>
      <li v-for="(item, index) in friends" :key="index">
        <img :src="item.fromUserHead?item.fromUserHead:require('../../../build/logo.png')" alt="" />
        <div class="uploadTitle">
          <span>{{ item.fromUserName }}</span>
          <span>{{
            item.chatcontent ? item.chatcontent : "请求加你为好友"
          }}</span>
        </div>
        <el-button
          size="mini"
          :type="item.alreadyread == 0 ? 'success' : 'info'"
          :disabled="item.alreadyread == 1"
          @click="Addfriends(item)"
          >{{ item.alreadyread == 0 ? "接受" : "已添加" }}</el-button>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  props: ["receiveData"],
  data() {
    return {
      friends: [],
    };
  },
  methods: {
    /**
     *宋建国：2019/12/6 22:45
     *描述：申请好友确认
     *版本：1.0
     */
    Addfriends(item) {
      this.axios({
        url:this.zuul+'/xyj-im/r/imRelationship/newCreateFriend',
        method:'post',
        data:{
          fromUserId:item.fromchatid,
          toUserId:item.tochatid,
          topic:this.$topic.$IMNEWS
        }
      }).then(res =>{
        this.$emit('updatebadge')
        this.find()
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
    /**
     *张俊娜：2020/10/16
     *描述：查找请求添加自己的好友
     *版本：1.0
     */
    find() {
      this.axios({
        url:this.zuul+'/xyj-im/r/imChatHistory/findNewFriend',
        method:'get',
        params:{
          chatId:sessionStorage.getItem('chatid')
        }
      }).then(res => {
        this.friends = []
        this.friends = res.data;
        if(this.friends.length>0){
          this.$emit('showFriends')
        }
      }).catch(err => {
        this.$message.error(err.message)
      })
    },
  },
  mounted() {
   
  },
};
</script>

<style lang="scss" scoped>
ul {
  margin: 0;
  padding: 15px;
  box-sizing: border-box;
  li {
    list-style: none;
    box-sizing: border-box;
    padding-bottom: 10px;
    border-bottom: 1px solid #ccc;
    display: flex;
    justify-content: space-between;
    img {
      width: 30px;
      height: 35px;
      vertical-align: top;
    }
    .uploadTitle {
      flex: 1;
      font-size: 12px;
      color: #000;
      box-sizing: border-box;
      padding: 0 10px;
      span {
        display: block;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/vueChart/friend.vue